export default __webpack_public_path__ + "static/media/adentis-novo-logo-dark-horizontal.5ba51696.svg";